/**
 * Oculta imágenes que no corresponden a variantes disponibles
 * Mejora el rendimiento usando Set y evita reprocesamiento
 */

(function() {
  'use strict';

  const SELECTORS = {
    container: '.product, [data-section-type="product"]',
    variantData: '[data-variant-json]',
    images: '.product__media img, .product__photo img, [data-media-id] img, .product-thumbnails__item img',
    imageContainers: '.product__media, .product__photo, [data-media-id], .scroll-slider__slide, .product-thumbnails__item'
  };

  /**
   * Extrae el nombre del archivo de una URL
   */
  function getFileName(url) {
    return url ? url.split('/').pop().split('?')[0] : '';
  }

  /**
   * Obtiene Set de nombres de archivos de variantes disponibles
   */
  function getAvailableImageNames(variants) {
    const imageNames = new Set();
    
    variants.forEach(variant => {
      if (variant?.available && variant?.featured_image?.src) {
        imageNames.add(getFileName(variant.featured_image.src));
      }
    });
    
    return imageNames;
  }

  /**
   * Oculta imagen o su contenedor padre
   */
  function hideImage(img) {
    const container = img.closest(SELECTORS.imageContainers);
    (container || img).style.display = 'none';
  }

  /**
   * Procesa y oculta imágenes no disponibles
   */
  function hideNonVariantImages() {
    const productContainer = document.querySelector(SELECTORS.container);
    if (!productContainer || productContainer.dataset.variantsProcessed) return;

    // Parsear variantes
    const variantElement = productContainer.querySelector(SELECTORS.variantData);
    if (!variantElement) return;

    let variants = [];
    try {
      variants = JSON.parse(variantElement.textContent);
      if (!Array.isArray(variants)) return;
    } catch (e) {
      console.error('Error parseando variantes:', e);
      return;
    }

    // Obtener Set de imágenes disponibles (búsqueda O(1) vs O(n))
    const availableImages = getAvailableImageNames(variants);
    if (availableImages.size === 0) return;

    // Procesar imágenes
    const images = productContainer.querySelectorAll(SELECTORS.images);
    images.forEach(img => {
      if (img.src && !availableImages.has(getFileName(img.src))) {
        hideImage(img);
      }
    });

    // Marcar como procesado para evitar ejecuciones múltiples
    productContainer.dataset.variantsProcessed = 'true';
  }

  // Ejecutar al cargar DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideNonVariantImages);
  } else {
    hideNonVariantImages();
  }

  // Retry para contenido cargado dinámicamente
  setTimeout(hideNonVariantImages, 1000);

})();
